import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78375542"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = ["aria-activedescendant"]
const _hoisted_3 = ["id", "aria-selected", "onClick", "onKeydown"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "divider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "modal-backdrop",
      onClick: $setup.hideModal
    }),
    _createVNode(_Transition, {
      appear: "",
      name: "slide-up"
    }, {
      default: _withCtx(() => [
        ($setup.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "modal-list",
                role: "listbox",
                "aria-activedescendant": 'option-' + $setup.selectedIndex
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.contents, (content, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: index,
                    ref_for: true,
                    ref: $setup.optionRefs[index],
                    id: `option-${index}`,
                    class: "select-row",
                    role: "option",
                    "aria-selected": $setup.selectedIndex === index ? 'true' : 'false',
                    onClick: ($event: any) => ($setup.onItemSelected(index)),
                    onKeydown: [
                      _withKeys(_withModifiers(($event: any) => ($setup.onKeyUp(index)), ["prevent"]), ["up"]),
                      _withKeys(_withModifiers(($event: any) => ($setup.onKeyDown(index)), ["prevent"]), ["down"]),
                      _withKeys(_withModifiers(($event: any) => ($setup.onItemSelected(index)), ["prevent"]), ["enter"]),
                      _withKeys(_withModifiers($setup.onEsc, ["prevent"]), ["esc"])
                    ],
                    tabindex: "0"
                  }, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(content), 1 /* TEXT */),
                    _withDirectives(_createVNode($setup["InlineSvg"], {
                      class: "img-checkmark",
                      src: require('@/assets/icons/check.svg'),
                      alt: "선택됨"
                    }, null, 8 /* PROPS */, ["src"]), [
                      [_vShow, $setup.selectedIndex === index]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_5, null, 512 /* NEED_PATCH */), [
                      [_vShow, index !== $props.contents.length - 1]
                    ])
                  ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_3))
                }), 128 /* KEYED_FRAGMENT */))
              ], 8 /* PROPS */, _hoisted_2)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}